export const vert = /*glsl*/ `
uniform mat4 textureMatrix;

varying vec4 worldPosition;
varying vec4 vUv;
varying vec2 vGeometryUv;

#include <common>
#include <fog_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>

void main() {
	vUv = textureMatrix * vec4( position, 1.0 );
	vGeometryUv = uv;
	worldPosition = modelMatrix * vec4( position, 1.0 );
	vec4 mvPosition =  modelViewMatrix * vec4( position, 1.0 );
	gl_Position = projectionMatrix * mvPosition;

	#include <beginnormal_vertex>
	#include <defaultnormal_vertex>
	#include <logdepthbuf_vertex>
	#include <fog_vertex>
	#include <shadowmap_vertex>
}`;
